function WidgetFormModel() {
  this.attributesForComponentInputs()
}

//model for form used in widget generator
WidgetFormModel.prototype = {

  //function used to remove hash from hex color value so that can be passed in widget parameters
  removeHashFromColor(colorValue) {
    let hex = colorValue || this.themeColor.value
    return hex.replace('#', '')
  },
  //reset color in ferryhopper color
  resetColorOnly() {
    this.themeColor = {
      value: '#01C3A7',
      inputType: 'color',
    }
  },
  //reset accent color
  resetAccentColorOnly() {
    this.accentColor = {
      value: '#01C3A7',
      inputType: 'color',
    }
  },
  //model made to fit the simpleInput component props
  attributesForComponentInputs: function() {
    this.affiliationCode = {
      value: '',
      inputType: 'text',
    }
    this.themeColor = {
      value: '#01C3A7',
      inputType: 'color',
    }
    this.accentColor = {
      value: '#01C3A7',
      inputType: 'color',
    }
    this.language = {
      value: 'el',
      inputType: 'text',
    }
    this.variant = {
      value: 'simple',
      inputType: 'text',
    }
    // Pre-filled search values
    this.fromPort = {
      value: '',
      inputType: 'text',
    }
    this.toPort = {
      value: '',
      inputType: 'text',
    }
    this.oneway = {
      value: false,
      inputType: 'checkbox',
    }
    // Display options
    this.noBorder = {
      value: false,
      inputType: 'checkbox',
    }
    this.noTitle = {
      value: false,
      inputType: 'checkbox',
    }
    this.noLogo = {
      value: false,
      inputType: 'checkbox',
    }
    // Whitelabel domain
    this.whitelabelDomain = {
      value: '',
      inputType: 'text',
    }
  },

  // Build the options parameter string
  buildOptionsString() {
    const options = []
    if (this.noBorder.value) options.push('noborder')
    if (this.noTitle.value) options.push('notitle')
    if (this.noLogo.value) options.push('nologo')
    return options.join(',')
  },
}

export default WidgetFormModel
